import { LOAD_MARKS, LOAD_MARKS_FILTERS, SET_MARKS_SELECTED_FILTERS, SET_MARKS_CURRENTPAGE, SET_MARKS_DISPLAYTYPE, SET_MARKS_TYPE, RESET_MARKS_SELECTED_FILTERS, SET_MARKS_LETTER, DELETE_MARKS_SELECTED_FILTERS, SET_MARKS_LENGTH, LOAD_MARKS_FAVORITE } from "./actions";
import _ from 'lodash';

const initialselectedfilters = {
  makers:'',
  metals:'',
  shapes:'',
  symbols:'',
  cities:'',
  countries:'',
  letters:'',
  daterange:'',
  search:null
}

const initialState = {
  marks:[],
  total:0,
  currentpage:0,
  totalpage:0,
  length:12,
  displaytype:'cards',
  type:'all',
  filters:[],
  selectedfilters:initialselectedfilters,
  favorites:[]
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOAD_MARKS:
      return {
        ...state,
        total:action.payload.total,
        currentpage:action.payload.currentpage,
        totalpage:action.payload.totalpage,
        marks:action.payload.items
      };
      break;
    case LOAD_MARKS_FILTERS:
      return {
        ...state,
        filters:action.payload
      };
      break;
    case SET_MARKS_CURRENTPAGE:
        return {
          ...state,
          currentpage: action.payload
        }
        break;
    case SET_MARKS_TYPE:
            return {
              ...state,
              selectedfilters:{
                ...state.selectedfilters,
                makers:null,
                metals:null
              },
              type: action.payload
            }
          break;
    case SET_MARKS_DISPLAYTYPE:
        return {
          ...state,
          displaytype: action.payload
        }
      break;
    case SET_MARKS_LENGTH:
        return {
          ...state,
          length: action.payload
        }
      break;
    case SET_MARKS_LETTER:
          return {
            ...state,
            selectedfilters:{
              ...state.selectedfilters,
              letters:action.payload.letters
            }
          }
        break;

    case RESET_MARKS_SELECTED_FILTERS:
          return {
            ...state,
            currentpage:0,
            selectedfilters:initialselectedfilters
          }
          break;
    case SET_MARKS_SELECTED_FILTERS:
        let newSelectedFilters = {...state.selectedfilters };
        newSelectedFilters[action.payload.filtername] = action.payload.filters
        return {
          ...state,
          currentpage:0,
          selectedfilters:newSelectedFilters
        }
        break;
    case DELETE_MARKS_SELECTED_FILTERS:
        let newSelectedFilters2 = {...state.selectedfilters };
        switch(action.payload.filtername){
          case "letters":
              const lettersArray = [...state.selectedfilters.letters];
              lettersArray.splice(action.payload.value, 1);
              newSelectedFilters2["letters"] = lettersArray.join("");
              break;
          case "symbols":
            _.remove(newSelectedFilters2[action.payload.filtername], {
                value: action.payload.value
            });
           
            
              break;
          default:
              newSelectedFilters2[action.payload.filtername] = '';
        }
        return {
          ...state,
          currentpage:0,
          selectedfilters:newSelectedFilters2
        }
        break;
        case LOAD_MARKS_FAVORITE:
          return {
            ...state,
            favorites: action.payload
          }
          break;
    default:
      return state;
  }
};
